module.exports = __webpack_public_path__ + "img/adivina-saludo-final.17bde528.svg";